import React from 'react';
import { Box } from '@wix/design-system';
import { ProductsGrid } from '@wix/package-picker-components';
import s from './GridHeader.scss';
import { AdvancedPlansProductData } from '../../../types';
import { RootStore, withInjectedRootStore } from 'providers';
import { useStudioProductCards } from '../hooks/useStudioProductCards';
import classNames from 'classnames';

interface GridHeaderProps {
  products: AdvancedPlansProductData[];
  innerRef?: React.RefObject<HTMLDivElement>;
  rootStore: RootStore;
  onClickSelect: (
    productData: AdvancedPlansProductData,
    clickSource?: string,
  ) => void;
}

const GridHeaderComp: React.FC<GridHeaderProps> = ({
  products,
  rootStore,
  onClickSelect,
  innerRef,
}) => {
  const productsCards = useStudioProductCards({
    baseProducts: products,
    appStore: rootStore.appStore,
    clickSource: 'table',
    onSelectProduct: onClickSelect,
    minimizedDisplay: true,
  });
  const { pricesIncludeTax, isAnonymous } = rootStore.appStore;

  const hatHeight = 24;

  return (
    <ProductsGrid.Header innerRef={innerRef} marginTop={hatHeight}>
      {productsCards.map((p, idx) => {
        const { title, cta, hat, price } = p.components;
        const zIndex = productsCards.length - idx;

        return (
          <ProductsGrid.Header.Cell
            zIndex={zIndex}
            className={classNames(s.headerCell, {
              [s.tax]: pricesIncludeTax,
              [s.anonymous]: isAnonymous,
            })}
          >
            <Box
              margin={`-${hatHeight}px 0px 0px 0px`}
              height={`${hatHeight}px`}
            >
              {hat}
            </Box>
            <Box align='center'>{title}</Box>
            <Box verticalAlign='middle' className={s.priceContainer}>
              {price}
            </Box>
            <Box className={s.cta} width='80%'>
              {cta}
            </Box>
          </ProductsGrid.Header.Cell>
        );
      })}
    </ProductsGrid.Header>
  );
};

export const GridHeader = withInjectedRootStore(GridHeaderComp);
